import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import "./login.css";
import Error from "../error/error";

function Login() {
    //Save password
    const [p, setP] = useState("");
    //Error
    const [errorMessage, setErrorMessage] = useState("");

    //Navigate to videos table page
    const navigate = useNavigate();

    useEffect(() => {
        const itemStr = localStorage.getItem("loginToken");
        if (itemStr){
            if (JSON.parse(itemStr).expiry < Date.now()) {
                localStorage.removeItem("loginToken");
            }
            else{
                navigate('/videos');
            }
        }
    },[]);

    const getWithExpiry = function() {
        const item = {
            value : Date.now(),
            expiry : Date.now()+ 86400000
        }
        localStorage.setItem("loginToken", JSON.stringify(item));
    }

    //save password
    const handlePassword = (e) => {
        if (errorMessage !== "" ){
            setErrorMessage("")
        }
        const value = e.target.value;
        setP(value);
    };

    //check valid password
    const checkLoginDitails = (e) => {
        e.preventDefault();
        const dp = 'cHJvZml0';
        if (p === atob(dp)){
            getWithExpiry();
            // if correct, show videos table
            navigate("/videos");
        }
        else{
            const input = document.getElementsByClassName('login-input');
            input['password'].value = "";
            setErrorMessage("incorrect password, please try again");
        }
    };

    return (
        <div className="login-page">
            <div>
                <img src="https://marketing-emails-images.s3.amazonaws.com/Generator/AdMaven_Logo_Gradient.svg" className="logo" alt="description"></img>
            </div>
            <div className="login-form">
                <div className="form-left">
                    <div className="video-title">
                    video banner
                    </div>
                </div>
                <div className="form-right">
                <div className="login-title">
                    Login
                </div>
                <form onSubmit={(e) => {checkLoginDitails(e)}}>
                    <div className="login-pass">
                        <p>Please enter password: </p>
                        <input type="text" name="password" className="login-input" onChange={handlePassword}></input>
                        {errorMessage ? <Error text={errorMessage}/> :  null}
                    </div>
                    <div className="login-pass">
                        <button className="login-btn">LOGIN</button>
                    </div>
                </form>
                </div>
            </div>
        </div>

    );
}

export default Login;
